<template>
    <div>
      <section class="pt-8">
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <p class="title is-5 mb-1">Upload of mandatory documents</p>
            </div>
          </div>
        </div>
      </section>
        <card-component class="border-round">

        <v-card flat class="px-2">
          <v-row v-if="isSuperAdmin">
            <v-col  cols="12" md="3" sm="4"  class="pl-6 pr-6">
              <label class="font-weight-medium body-2">
             Document Type <span class="red--text">*</span></label>

              <multiselect class="overflowmultiselect2" label="label" track-by="value"
                :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                :preselect-first="false" :multiple="true" :options="documentTypes"
                v-model="selectedDocuments"                 >
                <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single"
                  v-if="values.role && !isOpen">{{ values }} </span>
                </template>
              </multiselect>

            </v-col>
            <v-col cols="12" md="3"  sm="4" class="pr-6">
              <label class="font-weight-medium body-2">Franchisee<span class="error--text ml-1">*</span></label>

                <multiselect class="overflowmultiselect2" label="companyName" track-by="companyName"
                  :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                  :preselect-first="false" :multiple="true" :options="franchiseeList"
                  v-model="selectedCenterIds">
                  <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single"
                    v-if="values.role && !isOpen">{{ values.companyName }} </span>
                  </template>
                </multiselect>

            </v-col>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2"
                  >academic year
                  <span class="error--text">*</span></label
                >
                <v-autocomplete
                  class="my-0 py-1"
                  v-model="academicYearID"
                  :items="academicYears"
                  @change="getData()"
                  key="id"
                  item-value="id"
                  item-text="academicYear"
                >
                </v-autocomplete>
              </v-col>

                <v-btn color="success" class="mr-6" @click="getdataforadmin()" :disabled="!academicYearID || !selectedDocuments?.length">
                  <v-icon left size="18">mdi-text-box-check-outline</v-icon>
                  Submit
                </v-btn>

                <v-btn color="primary"  class="mr-6 " @click="downloadCSV" :disabled="!cctvData.length">
                  <v-icon left>mdi-download</v-icon>
                  Export
                </v-btn>

                  <v-btn color="gray" class="mr-6" @click="resetfilters()">
                  <v-icon left>mdi-refresh</v-icon>
                  Reset
                </v-btn>
          </v-row>
        </v-card>

        <template v-if="!isSuperAdmin">
          <div class="columns is-vcentered is-mobile">
            <!-- Label -->
            <div class="column is-narrow">
              <div class="content">
                <b class=" ">Select Document Type:</b>
              </div>
            </div>

            <!-- Dropdown -->
            <div class="column">
              <b-field class="m-0">
                <b-select
                  v-model="selectedDocumentType"
                  placeholder="Select a document type"
                  @input="handleDocumentChange"
                >
                  <option
                    v-for="type in documentTypes"
                    :key="type.value"
                    :value="type.value"
                  >
                    {{ type.label }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </template>
          <template v-if="documentTitle && (selectedDocumentType || admindocument)">
            <div class="evacuation-plan mb-2">
              <label class="title mb-1">{{ documentTitle }}</label>
              <span class="input-field"></span>
            </div>
          </template>
            <div v-if="selectedDocumentType || admindocument">
            <div >
              <form @submit.prevent="onSubmit">
            <!-- Social Media Declaration Form Upload -->

            <template v-if="selectedDocumentType === constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION
            || admindocument === constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION">

              <div class="letter-container box">
                <div class="text-center mb-4">
                  <h1 class="fw-bold document_title"><strong>To whom it may concern</strong></h1>
                </div>

                <div class="letter-body">
                  <p>
                    I Mr./Ms.
                    <input type="text" class="blank-input"  v-model="cctvForm.partnerName" placeholder="Enter BP name"  required/>
                    Business Partner of Firstcry Intellitots Preschool
                    <input type="text" class="blank-input" readonly v-model="cctvForm.centerName" placeholder="Enter center name" required />
                    center code
                    <input type="text" class="blank-input" readonly v-model="cctvForm.centerCode" placeholder="Enter center code" required />
                    confirm that Closed-Circuit Television (CCTV) cameras have been installed and are operational at the center.
                    The Total Number of Cameras are
                    <input type="number" class="blank-input" v-model="cctvForm.totalCameras" placeholder="Enter number of cameras" required/>
                    which covers the back up of CCTV for
                    <input type="number" class="blank-input" v-model="cctvForm.backupDays" placeholder="Enter backup days" required/>
                    days. The capacity of DVR (Digital Video Recorder) is
                    <input type="text" class="blank-input" v-model="cctvForm.dvrCapacity" placeholder="Enter DVR capacity" required/>.
                    Also, I acknowledge that the CCTV cameras have been strategically positioned to ensure there are no significant blind spots that compromise surveillance coverage.
                    We ensure that the back-up will suffice for any future needs.
                  </p>
                </div>

                <div class="mt-5">
                  <p><strong>Signature:</strong> <input type="text" class="blank-input" v-model="cctvForm.signature" placeholder="Signature" required/></p>
                  <p><strong>Name:</strong> <input type="text" class="blank-input" v-model="cctvForm.signedName" placeholder="Name" required/></p>
                  <p><strong>Date:</strong> <input type="date" readonly ="blank-input" placeholder="DD/MM/YYYY" v-model="cctvForm.date" required/></p>
                </div>

                <div class="field is-grouped is-grouped-right">
                  <div class="control">
                    <button class="button is-success" type="submit">
                    {{ documentId ? 'Edit' : 'Submit' }}
                    </button>
                  </div>
                  <div class="control">
                    <button class="button is-primary" type="button" v-if="!isSuperAdmin" @click="DownloadDocuments">
                    Download
                    </button>
                  </div>

                </div>
              </div>
            </template>

            <!-- POSH Committee Member List Form -->
                       <template v-if="selectedDocumentType === constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST || admindocument === constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST">
              <div class="letter-container box">
                <div class="text-end mb-3">
                  <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" alt="FCIT Logo" class="logo-img" />
                </div>

                <div class="text-center mb-5">
                  <h6 class="fw-bold document_title"><strong>FCIT: POSH Committee</strong></h6>
                </div>

                <div class="letter-body">
                  <p>
                    The formation of a POSH (Prevention of Sexual Harassment) Committee is an essential step for
                    FCIT centres to comply with the Sexual Harassment of Women at Workplace (Prevention,
                    Prohibition, and Redressal) Act, 2013 in India. The committee's role is to address complaints
                    of sexual harassment at the workplace, ensure a safe environment, and provide mechanisms
                    for grievance redressal.
                  </p>

                  <p class="fw-bold text-center document_title">
                    <strong>DECLARATION ON NOMINATION OF FCIT POSH COMMITTEE MEMBERS</strong>
                  </p>

                  <p>
                    I hereby declare the following individuals as FCIT
                    <input type="text" readonly class="blank-input" v-model="poshForm.branchName" placeholder="Branch Name" required />
                    (Branch name) POSH committee members for prompt redressal of concerns related to women's
                    workplace safety.
                  </p>

                  <ul class="committee-list pl-0">
                    <li class="mb-3"><strong>Chairperson:</strong> Meghashri Halder (Head of Academics)</li>
                    <li class="mb-3"><strong>Committee member 2:</strong> Naveen Dsouza (General Manager - Operations)</li>
                    <li class="mb-3">
                      <strong>Committee member 3:</strong>
                      <input type="text" class="blank-input commitee_width" v-model="poshForm.member3" placeholder="Enter name" required  /><br />
                      <small>(Academic Manager/Zonal Academic Manager)</small>
                    </li>
                    <li class="mb-3">
                      <strong>Committee member 4:</strong>
                      <input type="text" class="blank-input commitee_width"  v-model="poshForm.member4" placeholder="Enter name" required/><br />
                      <small>(Business Partner/Centre Head)</small>
                    </li>
                    <li class="mb-3"><strong>Committee member 5:</strong> Manjula Rao (Neutral Member)</li>
                  </ul>

                  <p class="mt-3">
                    <strong>N.B.</strong> Any changes in the committee members will be intimated to FCIT.
                  </p>
                </div>

                <div class="mt-5">
                  <p><strong>Date:</strong> <input type="date" readonly class="blank-input" placeholder="DD/MM/YYYY" v-model="poshForm.date" required /></p>
                  <p><strong>Centre Head:</strong> <input type="text" class="blank-input" v-model="poshForm.centreHead" placeholder="Centre Head Name" required/></p>
                  <p><strong>Branch name:</strong> <input type="text"  readonly  class="blank-input" v-model="poshForm.branchName" placeholder="Branch Name" required /></p>
                  <p><strong>Signature of Centre head:</strong> <input type="text" class="blank-input" v-model="poshForm.signature" placeholder="Signature" required  /></p>
                </div>

                  <div class="field is-grouped is-grouped-right">
                  <div class="control">
                    <button class="button is-success" type="submit">
                    {{ documentId ? 'Edit' : 'Submit' }}
                    </button>
                  </div>
                  <div class="control">
                    <button class="button is-primary" type="button" v-if="!isSuperAdmin" @click="DownloadDocuments">
                    Download
                    </button>
                  </div>
                </div>
              </div>

            </template>
            <template v-if="selectedDocumentType === constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL  || admindocument === constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL">
              <div class="letter-container box">
                <div class="text-center mb-4">
                  <h6 class="fw-bold document_title"><strong>CCTV Details</strong></h6>
                </div>

                <div class="letter-body">
                  <p>
                    As we prepare for the upcoming academic year, we are keen to gain a deeper understanding of
                    classroom dynamics and the effectiveness of our activity-based learning approach. To achieve this,
                    we are requesting access to live CCTV footage from your classrooms. This will allow us to observe
                    student behavior, teacher interactions, and overall classroom environment.
                  </p>

                  <p>
                    By analyzing these observations, we hope to identify areas where we can improve our curriculum,
                    teaching methods, and classroom management strategies. Our goal is to create a more engaging
                    and effective learning experience for all students.
                  </p>

                  <p>
                    We strictly adhere to all privacy and security protocols.
                  </p>

                  <p>
                    To facilitate this observation, we kindly request you to provide the following details:
                  </p>
                </div>

                <div class="table-responsive">
                  <table class="table table-bordered details-table center_name">
                    <thead>
                      <tr>
                        <th class=""><strong>Centre name:</strong><input type="text" class="blank-input" readonly v-model="cctvDetailsForm.centreName" placeholder="Enter centre name" required/></th>
                        <th class=""><strong>City:</strong><input type="text" class="blank-input" v-model="cctvDetailsForm.city" placeholder="Enter city" required/></th>
                        <th class=""><strong>State/UT:</strong><input type="text" class="blank-input" v-model="cctvDetailsForm.state" placeholder="Enter state or UT" required/></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Router Details</td>
                        <td colspan="2"><input type="text" class="blank-input" v-model="cctvDetailsForm.routerDetails" placeholder="Enter router details" required /></td>
                      </tr>
                      <tr>
                        <td>NVR Details</td>
                        <td colspan="2"><input type="text" class="blank-input"  v-model="cctvDetailsForm.nvrDetails" placeholder="Enter NVR details" required/></td>
                      </tr>
                      <tr>
                        <td>DVR Details</td>
                        <td colspan="2"><input type="text" class="blank-input" v-model="cctvDetailsForm.dvrDetails" placeholder="Enter DVR details" required/></td>
                      </tr>
                      <tr>
                        <td>Username</td>
                        <td colspan="2"><input type="text" class="blank-input" v-model="cctvDetailsForm.username" placeholder="Enter username" required/></td>
                      </tr>
                      <tr>
                        <td>Password</td>
                        <td colspan="2"><input type="text" class="blank-input" v-model="cctvDetailsForm.password" placeholder="Enter password" required/></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="mt-4">
                  <p class="mb-0">
                    Your cooperation in sharing this information will be greatly appreciated. We are confident that
                    this collaboration will benefit both our organization and your school.
                  </p>
                </div>

                <div class="field is-grouped is-grouped-right">
                  <div class="control">
                    <button class="button is-success" type="submit">
                    {{ documentId ? 'Edit' : 'Submit' }}
                    </button>
                  </div>
                  <div class="control">
                    <button class="button is-primary" type="button" v-if="!isSuperAdmin" @click="DownloadDocuments">
                    Download
                    </button>
                  </div>
                </div>
              </div>
            </template>
              <!-- FCIT Safety Committee Member List Form -->

              <template v-if="selectedDocumentType === constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST || admindocument === constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST">
                <div class="letter-container box">
                  <div class="text-end mb-3">
                    <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" alt="FCIT Logo" class="logo-img" />
                  </div>

                  <div class="text-center mb-4">
                    <h1 class="fw-bold document_title"><strong>FCIT Safety Committee</strong></h1>
                  </div>

                  <div class="letter-body">
                    <p>
                      Firstcry Intellitots (FCIT) has established norms for setting up a safety committee to
                      safeguard the interests of children & ensure utmost safety-security in the premises. “School
                      Safety” has been defined as creating a safe environment for children, starting from their
                      homes to their schools and back. This includes safety from any kind of abuse, violence,
                      psycho-social issues, disaster: natural and manmade, fire, transportation (excerpts from
                      MSCS,2021-NCPCR).
                    </p>

                    <p>
                      The FCIT safety committee is responsible for prompt redressal of concerns related to child
                      safety. Business partners should nominate members from the center.
                    </p>

                    <p>
                      Based on the severity, the safety concerns are categorized into Green, Amber & Red (refer
                      safety manual).
                    </p>
                  </div>

                  <div class="row mt-4">
                    <div class="col-md-6">
                      <table class="table table-bordered text-center align-middle safety-table w-100">
                        <thead>
                          <tr>
                            <th colspan="3" class="text-warning fw-bold">Amber & Green cases</th>
                          </tr>
                          <tr>
                            <th>Sl.No.</th>
                            <th>Committee members</th>
                            <th>No.</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Center head</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Business Partner*</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Senior Teacher (vintage more than 6months)**</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>Regional Operations Manager-FCIT</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>Academic Manager-FCIT****</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td colspan="2" class="fw-bold"><strong>Total committee members</strong></td>
                            <td class="fw-bold">5</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-md-6">
                      <table class="table table-bordered text-center align-middle safety-table w-100">
                        <thead>
                          <tr>
                            <th colspan="3" class="text-danger text-white fw-bold">Red cases</th>
                          </tr>
                          <tr>
                            <th>Sl.No.</th>
                            <th>Committee Members</th>
                            <th>No.</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Center head</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Business Partner*</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Senior Teacher (vintage more than 6months)**</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>Zonal Operations Manager-FCIT</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>Zonal Academic Manager-FCIT****</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td colspan="2" class="fw-bold"><strong>Total committee members</strong></td>
                            <td class="fw-bold">5</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="mt-4">
                    <p><strong>N.B.</strong></p>
                    <ul class="pl-0">
                      <li>* In case BP is the CH, one person from trust should be a committee member</li>
                      <li>**In case of attrition of nominated senior teacher, another teacher to be added to the committee</li>
                      <li>***In case of escalation, Zonal Academic Manager (ZAM) will be consulted.</li>
                      <li>****In case of escalation, Head of Academics (HOA) will be consulted.</li>
                    </ul>
                  </div>
                </div>
                <div class="letter-container box">
                  <div class="text-end mb-3">
                    <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" alt="FCIT Logo" class="logo-img" />
                  </div>

                  <p class="fw-bold text-center document_title">
                    <strong>DECLARATION ON NOMINATION OF FCIT SAFETY COMMITTEE MEMBERS</strong>
                  </p>

                  <p>
                    I hereby declare the following individuals as FCIT
                    <input type="text" class="blank-input commitee_width" pv-model="safetyForm.branchName" v-model="safetyForm.branchName"  placeholder="Branch Name" required/>
                    safety committee members for prompt redressal of concerns related to child safety.
                  </p>

                  <div class="committee-list">
                    <p><strong>1. Committee Member 1:</strong>
                      <input type="text" class="blank-input commitee_width" v-model="safetyForm.member1" placeholder="Centre Head" required  />
                      <br /><small>(Centre Head)</small>
                    </p>

                    <p><strong>2. Committee Member 2:</strong>
                      <input type="text" class="blank-input commitee_width" v-model="safetyForm.member2" placeholder="Business Partner or Trust Member" required />
                      <br /><small>(Business Partner or member of the Trust)</small>
                    </p>

                    <p><strong>3. Committee Member 3:</strong>
                      <input type="text" class="blank-input commitee_width" v-model="safetyForm.member3" placeholder="Senior Teacher" required/>
                      <br /><small>(Senior Teacher)</small>
                    </p>

                    <p><strong>4. Committee Member 4:</strong>
                      <input type="text" class="blank-input commitee_width" v-model="safetyForm.member4" placeholder="ROM Name" required/>
                      <br /><small>(FCIT representative - ROM)</small>
                    </p>

                    <p><strong>5. Committee Member 5:</strong>
                      <input type="text" class="blank-input commitee_width" v-model="safetyForm.member5" placeholder="AM Name" required/>
                      <br /><small>(FCIT representative - AM)</small>
                    </p>
                  </div>

                  <p class="mt-3">
                    <strong>N.B.</strong> Any changes in the committee members will be intimated to FCIT.
                  </p>

                  <div class="row mt-4">
                    <div class="col-md-6">
                      <p><strong>Date:</strong> <input type="text" class="blank-input commitee_width" placeholder="DD/MM/YYYY" v-model="safetyForm.date" required /></p>
                    </div>
                    <div class="col-md-6">
                      <p><strong>Branch Name:</strong> <input type="text" class="blank-input commitee_width" v-model="safetyForm.branchName" placeholder="Branch Name" required  /></p>
                    </div>
                    <div class="col-md-6">
                      <p><strong>Centre Head:</strong><input type="text" class="blank-input commitee_width" v-model="safetyForm.centreHead" placeholder="Centre Head Name" /></p>
                    </div>

                    <div class="col-md-6">
                      <p><strong>Signature:</strong><input type="text" class="blank-input commitee_width" v-model="safetyForm.signature" placeholder="Signature" required /></p>
                    </div>
                  </div>
                   <div class="field is-grouped is-grouped-right">
                    <div class="control">
                      <button class="button is-success" type="submit">
                      {{ documentId ? 'Edit' : 'Submit' }}
                      </button>
                    </div>
                    <div class="control">
                    <button class="button is-primary" type="button" v-if="isSuperAdmin" @click="DownloadDocuments">
                    Download
                    </button>
                    </div>
                  </div>
                </div>

              </template>
               </form>
               </div>
            </div>
        </card-component>
      <div v-if="cctvData.length &&  !isSuperAdmin" class="mt-6">
        <v-data-table item-key="id" :items="cctvData" :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }" :items-per-page="10" :headers="headers">
          <template v-slot:item.documents="{ item }">
            <div>
              <v-row no-gutters>
                <v-col cols="12" md="11" class="ma-0 pa-0">
                  <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                    v-if="item.filePath" @click="openFile(item.filePath)">CCTV Document
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
              <!-- <router-link :to="{ name: 'cctvDocEdit', params: { cctvDocId: item.id } }"> -->
                <v-btn outlined color="success" class="px-2 ml-1 ma-1" min-width="0" small @click="onDocumentView(item)">
                  View
                </v-btn>
              <!-- </router-link> -->
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
      </div>
       <div v-if=" isSuperAdmin " >
        <v-data-table item-key="id" :items="cctvData" :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }" :items-per-page="10" :headers="headers1">
          <template v-slot:item.documents="{ item }">
            <div>
              <v-row no-gutters>
                <v-col cols="12" md="11" class="ma-0 pa-0">
                  <v-btn class="px-2 ml-1 ma-1" outlined min-width="0" color="primary" text small
                    v-if="item.filePath" @click="openFile(item.filePath)">CCTV Document
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
              <!-- <router-link :to="{ name: 'cctvDocEdit', params: { cctvDocId: item.id } }"> -->

                <v-btn outlined color="success" class="px-2 ml-1 ma-1" min-width="0" @click="onEditDocument(item)" small>
                  Edit
                </v-btn>
              <!-- </router-link> -->
               <v-btn outlined color="success" class="px-2 ml-1 ma-1" min-width="0" @click="onDocumentView(item)" small>
                  View
                </v-btn>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
      </div>
      <loading-icon :value="isLoading" />
      <div v-if="viewdocument">
      <DocumentView
        :visible="viewdocument"
        :selectedDocumentType="selectedDocument"
        :documentData="document"
        :constants="constants"
        :documentId="documentId || documentid"
        @close="viewdocument = false; printable = false"
        :printable="printable"

      />
      </div>
    </div>
</template>

<script>
import CardComponent from '@/components/template/CardComponent'
import { mapGetters } from 'vuex'
import constants from '@/utils/constants'
import Utils from '@/utils'
import moment from 'moment'
import stores from '@/stores'
import Multiselect from 'vue-multiselect'
import DocumentView from './doucmentView.vue'

export default {
  name: 'mandateDocsUpload',
  components: {
    CardComponent, Multiselect, DocumentView
  },

  data () {
    return {
      dropFiles: [],
      isSuperAdmin: stores.user.ACL.superAdmin,
      allowedFormats: ['image/png', 'application/pdf', 'image/jpeg'],
      userObj: {
        cctvDocUpload: null
      },
      isLoading: false,
      franchiseeList: [],
      academicYears: [],
      selectedCenterIds: [],
      academicYearID: '',
      selectedDocuments: [],
      franchiseeId: '',
      admindocument: null,
      headers: [
        { text: 'Name', value: 'modifiedFields', sortable: true },
        { text: 'Uploaded Date', value: 'updatedAtDate', sortable: false },
        { text: 'Uploaded Time', value: 'updatedAtTime', sortable: false },
        // { text: 'Documents', value: 'documents', sortable: false },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      headers1: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Franchisee Name', value: 'franchiseeName', sortable: true },
        { text: 'Uploaded Date', value: 'updatedAtDate', sortable: false },
        { text: 'Uploaded Time', value: 'updatedAtTime', sortable: false },
        { text: 'Documents', value: 'documentName', sortable: false },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      csvheaders: [
        { text: 'Document Name', value: 'documentName' },
        { text: 'Center Name', value: 'franchiseeName' },
        { text: 'Center Code', value: 'centerCode' },
        { text: 'Last Updated Field', value: 'fieldName' },
        { text: 'Current Value', value: 'currentValue' },
        { text: 'Old Value', value: 'oldValue' },
        { text: 'Last Modified Date', value: 'updatedAtDate' },
        { text: 'Academic Year', value: 'academicYear' }
      ],
      cctvData: [],
      modules: {
        DownloadDocuments: this.checkModuleAccess('DownloadDocuments'), // listing/view document
        uploadCctvDocument: this.checkModuleAccess('uploadCctvDocument')
      },
      documentTypes: [
        { label: 'CCTV Declaration Form', value: constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION },
        // { label: 'Social Media declaration form', value: constants.UPLOAD_MANDATE_FORM.SOCIAL_MEDIA_DECLARATION },
        { label: 'CCTV make and model with NVR|DVR details', value: constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL },
        { label: 'POSH committee member list', value: constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST },
        { label: 'Safety (POCSO) Committee Member List', value: constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST }
        // { label: 'GTBT Signage', value: constants.UPLOAD_MANDATE_FORM.GTBT_SIGNAGE }
      ],
      selectedDocumentType: null,
      selectedDocument: null,
      documentTitle: '',
      isValidDocumentUploaded: false,
      userDetails: stores.user || {},

      cctvForm: {
        partnerName: '',
        centerName: stores.user.franchisee?.companyName || '',
        centerCode: String(stores.user.franchisee?.id || ''),
        totalCameras: '',
        backupDays: '',
        dvrCapacity: '',
        signature: '',
        signedName: '',
        date: new Date().toISOString().slice(0, 10)
      },
      poshForm: {
        branchName: stores.user.franchisee?.companyName || '',
        member3: '',
        member4: '',
        date: new Date().toISOString().slice(0, 10),
        centreHead: '',
        signature: ''
      },
      cctvDetailsForm: {
        centreName: stores.user.franchisee?.companyName || '',
        routerDetails: '',
        nvrDetails: '',
        dvrDetails: '',
        username: '',
        password: '',
        city: '',
        state: stores.user.franchisee?.state || ''
      },
      safetyForm: {
        branchName: stores.user.franchisee?.companyName || '',
        member1: '',
        member2: '',
        member3: '',
        member4: '',
        member5: '',
        date: new Date().toISOString().slice(0, 10),
        centreHead: '',
        signature: ''
      },
      documentId: null,
      documentData: null,
      viewdocument: false,
      document: null,
      documentid: null,
      printable: false

    }
  },

  created: async function () {
    if (this.isSuperAdmin) {
      this.getFranchisee()
      this.getAcademicYear()
    }
    await this.onFranchiseeChange()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    constants () {
      return constants
    }
  },
  watch: {
    selectedDocumentType: function (newVal) {
      this.resetdata()
      this.cctvData = []
      this.documentId = null
      if (!this.franchiseeId && this.selectedDocumentType !== null) {
        this.selectedDocumentType = null
        this.errMsg('Please select Franchisee')
        this.resetdata()
        return
      }
      if (!this.academicYearID && this.selectedDocumentType !== null) {
        this.selectedDocumentType = null
        this.errMsg('Please select Academic Year')
        this.resetdata()
        return
      }
      this.getData()
    },
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYearID: async function (val) {
      await this.onFranchiseeChange()
    }
  },

  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeId = this.franchisee.id
        } else {
          this.franchiseeId = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.resetpage()
        // this.getData()
        this.inProgress = false
      }
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    handleFileUpload (files) {
      if (this.checkValidFileSize(files)) {
        this.isValidDocumentUploaded = true
        this.dropFiles = files
      }
    },
    async onSubmit (event) {
      event.preventDefault()

      if (this.documentId) {
        this.onEdit()
        return
      }
      try {
        this.isLoading = true

        // CCTV Declaration (Acknowledgement)
        if (this.selectedDocumentType === this.constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION) {
        // Prepare payload as per API
          const f = this.cctvForm
          // You may need to get franchiseeId and academicYearId from user/session/context
          const franchiseeId = stores.user.franchisee.id || 1
          const academicYearId = stores.user.academicYear.id || 1
          if (
            !f.partnerName ||
        !f.centerName ||
        !f.centerCode ||
        !f.totalCameras ||
        !f.backupDays ||
        !f.dvrCapacity ||
        !f.signature ||
        !f.signedName ||
        !f.date
          ) {
            this.isLoading = false
            return this.errMsg('Please fill all required fields.')
          }
          const payload = {
            franchiseeId,
            businessPartner: f.partnerName.trim(),
            centerName: f.centerName.trim(),
            centerCode: f.centerCode.trim(),
            totalNumberOfCameras: Number(f.totalCameras),
            backupDays: Number(f.backupDays),
            capacityOfDVR: f.dvrCapacity.trim(),
            signature: f.signature.trim(),
            name: f.signedName.trim(),
            date: f.date,
            academicYearId
          }
          await http.post(`${constants.API_URL}/api/mandatory-documents/cctv-acknowledgement`, payload)
          this.okMsg('CCTV Acknowledgement has been successfully submitted!')
          // Reset form
          this.resetdata()
        } else if (this.selectedDocumentType === this.constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST) {
          const f = this.poshForm
          const franchiseeId = stores.user.franchisee.id || 1
          const academicYearId = stores.user.academicYear.id || 1
          if (
            !f.branchName ||
        !f.member3 ||
        !f.member4 ||
        !f.centreHead ||
        !f.signature
          ) {
            this.isLoading = false
            return this.errMsg('Please fill all required fields.')
          }
          const payload = {
            franchiseeId,
            branchName: f.branchName.trim(),
            committeeMember3: f.member3.trim(),
            committeeMember4: f.member4.trim(),
            centerHead: f.centreHead.trim(),
            signatureOfCenterHead: f.signature.trim(),
            academicYearId
          }
          await http.post(`${constants.API_URL}/api/mandatory-documents/posh-committee`, payload)
          this.okMsg('POSH Committee details submitted successfully!')
          // Reset form
          this.resetdata()
        } else if (this.selectedDocumentType === this.constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL) {
          const f = this.cctvDetailsForm
          const franchiseeId = stores.user.franchisee.id || 1
          const academicYearId = stores.user.academicYear.id || 1
          if (
            !f.centreName ||
        !f.city ||
        !f.state
          ) {
            this.isLoading = false
            return this.errMsg('Please fill all required fields.')
          }
          const payload = {
            centerName: f.centreName.trim(),
            city: f.city.trim(),
            stateOrUt: f.state.trim(),
            routerDetails: f.routerDetails.trim(),
            nvrDetails: f.nvrDetails.trim(),
            dvrDetails: f.dvrDetails.trim(),
            username: f.username.trim(),
            password: f.password.trim(),
            academicYearId,
            franchiseeId
          }
          await http.post(`${constants.API_URL}/api/mandatory-documents/cctv-details`, payload)
          this.okMsg('CCTV Details submitted successfully!')
          // Reset form
          this.resetdata()
        } else if (this.selectedDocumentType === this.constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST) {
          const f = this.safetyForm
          const franchiseeId = stores.user.franchisee.id || 1
          const academicYearId = stores.user.academicYear.id || 1
          if (
            !f.member1 ||
        !f.member2 ||
        !f.member3 ||
        !f.member4 ||
        !f.member5 ||
        !f.centreHead ||
        !f.branchName
          ) {
            this.isLoading = false
            return this.errMsg('Please fill all required fields.')
          }
          const payload = {
            committeeMember1: f.member1.trim(),
            committeeMember2: f.member2.trim(),
            committeeMember3: f.member3.trim(),
            committeeMember4: f.member4.trim(),
            committeeMember5: f.member5.trim(),
            centerHead: f.centreHead.trim(),
            branchName: f.branchName.trim(),
            signatureOfCenterHead: f.signature.trim(),
            academicYearId,
            franchiseeId
          }
          await http.post(`${constants.API_URL}/api/mandatory-documents/safety-committee`, payload)
          this.okMsg('Safety Committee details submitted successfully!')
          // Reset form
          this.resetdata()
        } else {
          this.isLoading = false
          return this.errMsg('Please select a valid document type.')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
        if (this.isSuperAdmin) {
          this.getdataforadmin()
        } else {
          this.getData()
        }
      }
    },
    deleteDropFile () {
      this.dropFiles = []
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    openFile: async function (path) {
      if (this.modules.DownloadDocuments) {
        try {
          this.isLoading = true
          let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${path}`)
          window.open(url.data)
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(`Error While getting file details, ${errorMessage}`)
        } finally {
          this.isLoading = false
        }
      } else {
        this.errMsg('You dont have access!')
        return false
      }
    },
    getData: async function () {
      try {
        if (this.isSuperAdmin) return
        if (!this.selectedDocumentType) return
        this.isLoading = true
        let apiUrl = ''
        // Select API endpoint based on selectedDocumentType
        switch (this.selectedDocumentType) {
          case this.constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION:
            apiUrl = `${constants.API_URL}/api/mandatory-documents/cctv-acknowledgement/logs/${this.franchiseeId}/${this.academicYearID}`
            break
          case this.constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST:
            apiUrl = `${constants.API_URL}/api/mandatory-documents/posh-committee/logs/${this.franchiseeId}/${this.academicYearID}`
            break
          case this.constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL:
            apiUrl = `${constants.API_URL}/api/mandatory-documents/cctv-details/logs/${this.franchiseeId}/${this.academicYearID}`
            break
          case this.constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST:
            apiUrl = `${constants.API_URL}/api/mandatory-documents/safety-committee/logs/${this.franchiseeId}/${this.academicYearID}`
            break
          default:
            this.isLoading = false
            this.cctvData = []
            return
        }

        const { data } = await http.get(apiUrl)
        if (!data || !Array.isArray(data) || data.length === 0) {
          this.cctvData = []
          this.isLoading = false
          return
        }
        this.cctvData = data[0].logs
        this.cctvData.map(a => {
          a.updatedAtDate = a.updatedAt
            ? moment(a.updatedAt).format('YYYY-MM-DD')
            : '-'
          a.updatedAtTime = a.updatedAt
            ? moment(a.updatedAt).format('HH:mm')
            : '-'
        })
        if (Array.isArray(this.cctvData) && this.cctvData.length > 0) {
          const entryId = data[0]?.entryId
          this.documentId = entryId
          if (entryId) {
            let apiPath = ''
            switch (this.selectedDocumentType) {
              case this.constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION:
                apiPath = `/api/mandatory-documents/cctv-acknowledgement/${entryId}`
                break
              case this.constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST:
                apiPath = `/api/mandatory-documents/posh-committee/${entryId}`
                break
              case this.constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL:
                apiPath = `/api/mandatory-documents/cctv-details/${entryId}`
                break
              case this.constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST:
                apiPath = `/api/mandatory-documents/safety-committee/${entryId}`
                break
              default:
                apiPath = ''
            }
            if (apiPath) {
              try {
                const res = await http.get(`${constants.API_URL}${apiPath}`)
                this.formdata = res.data
                // Bind fetched data to the corresponding form object based on selectedDocumentTypecatch (e) {
                if (res && res.data) {
                  this.documentData = res.data
                  switch (this.selectedDocumentType) {
                    case this.constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION:
                      Object.assign(this.cctvForm, {
                        partnerName: res.data.businessPartner || '',
                        centerName: this.franchisee?.companyName || '',
                        centerCode: res.data.centerCode || '',
                        totalCameras: res.data.totalNumberOfCameras || '',
                        backupDays: res.data.backupDays || '',
                        dvrCapacity: res.data.capacityOfDVR || '',
                        signature: res.data.signature || '',
                        signedName: res.data.name || '',
                        date: new Date(res.data.date).toISOString().slice(0, 10) || new Date().toISOString().slice(0, 10)
                      })
                      break
                    case this.constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST:
                      Object.assign(this.poshForm, {
                        branchName: res.data.branchName || '',
                        member3: res.data.committeeMember3 || '',
                        member4: res.data.committeeMember4 || '',
                        date: new Date(res.data.updatedAt).toISOString().slice(0, 10) || new Date().toISOString().slice(0, 10),
                        centreHead: res.data.centerHead || '',
                        signature: res.data.signatureOfCenterHead || ''
                      })
                      break
                    case this.constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL:
                      Object.assign(this.cctvDetailsForm, {
                        centreName: res.data.centerName || '',
                        routerDetails: res.data.routerDetails || '',
                        nvrDetails: res.data.nvrDetails || '',
                        dvrDetails: res.data.dvrDetails || '',
                        username: res.data.username || '',
                        password: res.data.password || '',
                        city: res.data.city || '',
                        state: res.data.stateOrUt || ''
                      })
                      break
                    case this.constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST:
                      Object.assign(this.safetyForm, {
                        branchName: res.data.branchName || '',
                        member1: res.data.committeeMember1 || '',
                        member2: res.data.committeeMember2 || '',
                        member3: res.data.committeeMember3 || '',
                        member4: res.data.committeeMember4 || '',
                        member5: res.data.committeeMember5 || '',
                        date: new Date(res.data.updatedAt).toISOString().slice(0, 10) || new Date().toISOString().slice(0, 10),
                        centreHead: res.data.centerHead || '',
                        signature: res.data.signatureOfCenterHead || ''
                      })
                      break
                    default:
                      // No action
                      break
                  }
                }
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data && e.response.data.message) || e.message
                this.errMsg(`Error fetching document details: ${errorMessage}`)
              }
            }
          }
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    handleDocumentChange (selectedValue) {
      // Find the selected type and update the title
      this.dropFiles = []
      const selectedType = this.documentTypes.find((doc) => doc.value === selectedValue)
      this.documentTitle = selectedType ? selectedType.label : 'Please select a document'
    },
    checkValidFileSize (file) {
      if (!file || !file.name) return false
      const maxFileSize = 10 * 1024 * 1024
      // Check for allowed formats
      if (!this.allowedFormats.includes(file.type)) {
        this.deleteDropFile()
        this.errMsg('Invalid file format. Please upload a JPG or PDF file.')
        return false
      }

      // Check for file size
      if (file.size > maxFileSize) {
        this.deleteDropFile()
        this.errMsg('File size too large. Please upload a file under 10MB.')
        return false
      }

      return true // File is valid
    },

    getFranchisee: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee/active`)
        const data = response.data
        if (data.rows.length > 1) {
          this.franchiseeList = data.rows
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      } finally {
      }
    },
    getAcademicYear: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        const data = response.data
        this.academicYears = data.rows

        this.academicYearID = stores.user.academicYear?.id || (data.rows.length ? data.rows[0].id : null)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      } finally {
      }
    },
    getdataforadmin: async function () {
      try {
        this.isLoading = true
        // Prepare payload for API
        const payload = {
          documentNames: this.selectedDocuments.map(doc => doc.value),
          academicYearId: this.academicYearID,
          franchiseeIds: Array.isArray(this.selectedCenterIds) && this.selectedCenterIds.length
            ? this.selectedCenterIds.map(franchisee => Number(franchisee.id))
            : undefined
        }

        const { data } = await http.post(`${constants.API_URL}/api/mandatory-documents/get`, payload)
        if (Array.isArray(data)) {
          data.forEach(row => {
            const franchisee = this.franchiseeList.find(f => f.id === row.entryId.franchiseeId)
            const academicYear = this.academicYears.find(ay => ay.id === row.entryId.academicYearId)
            row.name = row.entryId.name || row.entryId.centerHead || 'N/A'
            row.franchiseeName = franchisee ? franchisee.companyName : ''
            row.academicYear = academicYear ? academicYear.academicYear : ''
            row.updatedAtDate = row.entryId.updatedAt
              ? moment(row.entryId.updatedAt).format('YYYY-MM-DD')
              : '-'
            row.updatedAtTime = row.entryId.updatedAt
              ? moment(row.entryId.updatedAt).format('hh:mm A')
              : '-'
          })
        }
        this.cctvData = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data && e.response.data.message) || e.message
        this.errMsg(`Error fetching second last modification data: ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    async onEdit () {
      try {
        this.isLoading = true
        let payload = {}
        let apiPath = ''
        const document = this.selectedDocumentType || this.admindocument || ''
        // Compare form data with documentData and only send changed fields
        if (document === this.constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION) {
          const f = this.cctvForm
          const d = this.documentData || {}
          if (f.partnerName !== d.businessPartner) payload.businessPartner = f.partnerName.trim()
          if (f.centerCode !== d.centerCode) payload.centerCode = f.centerCode.trim()
          if (String(f.totalCameras) !== String(d.totalNumberOfCameras)) payload.totalNumberOfCameras = Number(f.totalCameras)
          if (String(f.backupDays) !== String(d.backupDays)) payload.backupDays = Number(f.backupDays)
          if (f.dvrCapacity !== d.capacityOfDVR) payload.capacityOfDVR = f.dvrCapacity.trim()
          if (f.signature !== d.signature) payload.signature = f.signature.trim()
          if (f.signedName !== d.name) payload.name = f.signedName.trim()
          // payload.date = new Date().toISOString().slice(0, 10)
          apiPath = `/api/mandatory-documents/cctv-acknowledgement/${this.documentId}`
        } else if (document === this.constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST) {
          const f = this.poshForm
          const d = this.documentData || {}
          if (f.branchName !== d.branchName) payload.branchName = f.branchName.trim()
          if (f.member3 !== d.committeeMember3) payload.committeeMember3 = f.member3.trim()
          if (f.member4 !== d.committeeMember4) payload.committeeMember4 = f.member4.trim()
          if (f.centreHead !== d.centerHead) payload.centerHead = f.centreHead.trim()
          if (f.signature !== d.signatureOfCenterHead) payload.signatureOfCenterHead = f.signature.trim()
          apiPath = `/api/mandatory-documents/posh-committee/${this.documentId}`
        } else if (document === this.constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL) {
          const f = this.cctvDetailsForm
          const d = this.documentData || {}
          if (f.centreName !== d.centerName) payload.centerName = f.centreName.trim()
          if (f.city !== d.city) payload.city = f.city.trim()
          if (f.state !== d.stateOrUt) payload.stateOrUt = f.state.trim()
          if (f.routerDetails !== d.routerDetails) payload.routerDetails = f.routerDetails.trim()
          if (f.nvrDetails !== d.nvrDetails) payload.nvrDetails = f.nvrDetails.trim()
          if (f.dvrDetails !== d.dvrDetails) payload.dvrDetails = f.dvrDetails.trim()
          if (f.username !== d.username) payload.username = f.username.trim()
          if (f.password !== d.password) payload.password = f.password.trim()
          apiPath = `/api/mandatory-documents/cctv-details/${this.documentId}`
        } else if (document === this.constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST) {
          const f = this.safetyForm
          const d = this.documentData || {}
          if (f.member1 !== d.committeeMember1) payload.committeeMember1 = f.member1.trim()
          if (f.member2 !== d.committeeMember2) payload.committeeMember2 = f.member2.trim()
          if (f.member3 !== d.committeeMember3) payload.committeeMember3 = f.member3.trim()
          if (f.member4 !== d.committeeMember4) payload.committeeMember4 = f.member4.trim()
          if (f.member5 !== d.committeeMember5) payload.committeeMember5 = f.member5.trim()
          if (f.centreHead !== d.centerHead) payload.centerHead = f.centreHead.trim()
          if (f.branchName !== d.branchName) payload.branchName = f.branchName.trim()
          if (f.signature !== d.signatureOfCenterHead) payload.signatureOfCenterHead = f.signature.trim()
          apiPath = `/api/mandatory-documents/safety-committee/${this.documentId}`
        } else {
          this.isLoading = false
          return this.errMsg('Invalid document type for edit.')
        }
        if (Object.keys(payload).length === 0) {
          this.isLoading = false
          return this.errMsg('No changes detected.')
        }
        if (document === this.constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION) {
          payload.date = new Date().toISOString().slice(0, 10)
        }
        await http.patch(`${constants.API_URL}${apiPath}`, payload)
        this.okMsg('Document updated successfully!')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        if (!this.isSuperAdmin) {
          this.getData()
        } else {
          this.getdataforadmin()
        }

        this.isLoading = false
        if (this.isSuperAdmin) {
          this.selectedDocumentType = null
          this.admindocument = null
        }
      }
    },
    onDocumentView: async function (item) {
      this.selectedDocument = this.selectedDocumentType || item.documentName
      this.document = item
      this.viewdocument = true
      this.documentid = item.id
    },
    resetdata () {
      // Reset all forms
      this.documentId = null
      this.cctvForm = {
        partnerName: '',
        centerName: this.franchisee?.companyName || '',
        centerCode: String(this.franchisee?.id || ''),
        totalCameras: '',
        backupDays: '',
        dvrCapacity: '',
        signature: '',
        signedName: '',
        date: new Date().toISOString().slice(0, 10)
      }
      this.poshForm = {
        branchName: this.franchisee?.companyName || '',
        member3: '',
        member4: '',
        date: new Date().toISOString().slice(0, 10),
        centreHead: '',
        signature: ''
      }
      this.cctvDetailsForm = {
        centreName: this.franchisee?.companyName || '',
        routerDetails: '',
        nvrDetails: '',
        dvrDetails: '',
        username: '',
        password: '',
        city: '',
        state: this.franchisee?.state || ''
      }
      this.safetyForm = {
        branchName: this.franchisee?.companyName || '',
        member1: '',
        member2: '',
        member3: '',
        member4: '',
        member5: '',
        date: new Date().toISOString().slice(0, 10),
        centreHead: '',
        signature: ''
      }
    },
    resetpage () {
      this.selectedDocumentType = null
      this.documentTitle = ''
      this.dropFiles = []
      this.cctvData = []
      this.documentId = null
      this.documentData = null
      this.resetdata()
    },
    resetfilters () {
      this.selectedDocuments = []
      this.selectedCenterIds = []
      this.academicYearID = stores.user.academicYear?.id
      this.cctvData = []
      this.selectedDocumentType = null
      this.admindocument = null
    },

    DownloadDocuments: async function () {
      this.printable = true
      this.selectedDocument = this.selectedDocumentType
      this.document = this.documentData
      this.viewdocument = true
      this.documentid = this.documentId
    },
    onEditDocument: function (item) {
      this.admindocument = item.documentName
      this.documentId = item.entryId.id
      switch (this.admindocument) {
        case this.constants.UPLOAD_MANDATE_FORM.CCTV_DECLARATION:
          Object.assign(this.cctvForm, {
            partnerName: item.entryId.businessPartner || '',
            centerName: item.entryId.centerName || '',
            centerCode: item.entryId.centerCode || '',
            totalCameras: item.entryId.totalNumberOfCameras || '',
            backupDays: item.entryId.backupDays || '',
            dvrCapacity: item.entryId.capacityOfDVR || '',
            signature: item.entryId.signature || '',
            signedName: item.entryId.name || '',
            date: item.entryId.date
              ? new Date(item.entryId.date).toISOString().slice(0, 10)
              : new Date().toISOString().slice(0, 10)
          })
          break
        case this.constants.UPLOAD_MANDATE_FORM.POSH_COMMITEE_LIST:
          Object.assign(this.poshForm, {
            branchName: item.entryId.branchName || '',
            member3: item.entryId.committeeMember3 || '',
            member4: item.entryId.committeeMember4 || '',
            date: item.entryId.date
              ? item.entryId.date
              : new Date().toISOString().slice(0, 10),
            centreHead: item.entryId.centerHead || '',
            signature: item.entryId.signatureOfCenterHead || ''
          })
          break
        case this.constants.UPLOAD_MANDATE_FORM.CCTV_MAKE_N_MODEL:
          Object.assign(this.cctvDetailsForm, {
            centreName: item.entryId.centerName || '',
            routerDetails: item.entryId.routerDetails || '',
            nvrDetails: item.entryId.nvrDetails || '',
            dvrDetails: item.entryId.dvrDetails || '',
            username: item.entryId.username || '',
            password: item.entryId.password || '',
            city: item.entryId.city || '',
            state: item.entryId.stateOrUt || ''
          })
          break
        case this.constants.UPLOAD_MANDATE_FORM.SAFETY_COMMITTEE_LIST:
          Object.assign(this.safetyForm, {
            branchName: item.entryId.branchName || '',
            member1: item.entryId.committeeMember1 || '',
            member2: item.entryId.committeeMember2 || '',
            member3: item.entryId.committeeMember3 || '',
            member4: item.entryId.committeeMember4 || '',
            member5: item.entryId.committeeMember5 || '',
            date: item.entryId.date
              ? item.entryId.date
              : new Date().toISOString().slice(0, 10),
            centreHead: item.entryId.centerHead || '',
            signature: item.entryId.signatureOfCenterHead || ''
          })
          break
      }
    },
    downloadCSV () {
      let csvContent = 'data:text/csv;charset=utf-8,'
      const headers = this.csvheaders.map(h => h.text).join(',')
      csvContent += headers + '\r\n'

      // Flatten cctvData: each modifiedFields entry becomes a row
      const rows = []
      this.cctvData.forEach(item => {
        const modifiedFields = Array.isArray(item.modifiedFields) && item.modifiedFields.length
          ? item.modifiedFields
          : [{ field: '', oldValue: '', currentValue: '' }]
        modifiedFields.forEach(fieldObj => {
          rows.push({
            documentName: item.documentName || '',
            franchiseeName: item.franchiseeName || (item.entryId?.centerName || ''),
            centerCode: item.entryId?.franchiseeId || '',
            fieldName: fieldObj.field || '',
            currentValue: item.entryId?.[fieldObj.field] !== undefined ? item.entryId[fieldObj.field] : '',
            oldValue: fieldObj.oldValue || '',
            updatedAtDate: item.updatedAtDate || (item.entryId?.updatedAt ? moment(item.entryId.updatedAt).format('YYYY-MM-DD') : ''),
            academicYear: item.academicYear || ''
          })
        })
      })

      rows.forEach(row => {
        const rowData = this.csvheaders.map(h => {
          const value = row[h.value] !== undefined ? row[h.value] : '-'
          return `"${String(value).replace(/"/g, '""')}"`
        }).join(',')
        csvContent += rowData + '\r\n'
      })

      const encodedUri = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'mandate_documents.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.truncated-text {
  cursor: pointer;
}

.evacuation-plan {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.title {
  font-weight: bold;
  margin-bottom: 4px;
}

.letter-container {
  background: #fff;
  padding: 30px;
  border: 1px solid #ccc;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.letter-container .logo-img {
  max-height: 60px;
}
.letter-body {
  text-align: justify;
  line-height: 1.8;
  font-size: 15px;
}

.letter-container .blank-input {
  border: none;
  border-bottom: 1px solid #000;
  outline: none;
  min-width: 120px;
  margin: 0 5px;
  background: transparent;
  font-size: 15px;
  padding: 2px 4px;
}

.letter-container .commitee_width{
  width: 400px;
}

.blank-input:focus {
  border-bottom: 2px solid #007bff;
  outline: none;
}

.letter-container .details-table th,
.letter-container .details-table td {
  vertical-align: middle;
  font-size: 15px;
}

.letter-container .details-table th {
  background: #f8f9fa;
}

.letter-container .table-bordered{
  border: 1px solid #eee;
}

.letter-container .table-bordered thead th{
  border-bottom: 1px solid #eee;
}

.letter-container .document_title{
  font-size: 20px;
}

.letter-container .text-warning {
  background-color: #ffc107 !important;
  color: #fff !important;
  text-align: center;
}

.letter-container .text-danger {
  background-color: #dc3545 !important;
  color: #fff !important;
  text-align: center;
}

.letter-container .safety-table{
  width: 100%;
}

.border-round{
  border-radius: 10px;
}

.letter-container .center_name tbody .blank-input{
  width: 100%;
}
</style>
